import { Segment, SEGMENTS } from '@sparknz/journeys-common';

export const CONTENT_ID: Record<Segment, string> = {
  [SEGMENTS.PERSONAL]: 'spark-personal',
  [SEGMENTS.BUSINESS]: 'spark-business',
  [SEGMENTS.LARGE_BUSINESS]: 'spark-lbg',
};

export const VARIATION: Record<Segment, string> = {
  [SEGMENTS.PERSONAL]: 'personal',
  [SEGMENTS.BUSINESS]: 'business',
  [SEGMENTS.LARGE_BUSINESS]: 'large_business_govt',
};
